import { useCallback, useEffect, useRef } from 'react';

const STICKY_CTA_OFFSET_PROPERTY = '--sticky-cta-offset';

function setOffset(value: number) {
  document.documentElement.style.setProperty(STICKY_CTA_OFFSET_PROPERTY, `${Math.ceil(value)}px`);
}

export function useStickyCtaOffset<T extends HTMLElement>() {
  const observerRef = useRef<ResizeObserver | null>(null);

  const ref = useCallback((node: T | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;
    if (!node) {
      setOffset(0);
      return;
    }
    setOffset(node.getBoundingClientRect().height);
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(() => setOffset(node.getBoundingClientRect().height));
    observer.observe(node);
    observerRef.current = observer;
  }, []);

  useEffect(
    () => () => {
      observerRef.current?.disconnect();
      setOffset(0);
    },
    []
  );

  return ref;
}
